import React, { useEffect, useState } from 'react';
import LayoutWithNavbar from './LayoutWithNavbar';
import { fetchStates, fetchInvoiceReport } from '../services/api';

const ReportPage = () => {
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [gstin, setGstin] = useState('');
  const [reportData, setReportData] = useState({});
  const [expandedGroups, setExpandedGroups] = useState({});

  useEffect(() => {
    const loadStates = async () => {
      const res = await fetchStates();
      if (res.success) setStates(res.data);
      else alert('Failed to fetch states');
    };
    loadStates();
  }, []);

  const getLast12Months = () => {
    const months = [];
    const today = new Date();
  
    for (let i = 0; i < 12; i++) {
      const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
      const monthShort = d.toLocaleString('default', { month: 'short' }); // May
      const yearFull = d.getFullYear(); // 2025
      const yearShort = `"${yearFull.toString().slice(-2)}`; // "25
  
      months.push({
        label: `${monthShort}-${yearFull}`, // eg: May-2025
        value: `${monthShort}${yearShort}`  // eg: May"25
      });
    }
  
    return months;
  };
  

  const handleSearch = async () => {
    const res = await fetchInvoiceReport({
      state: selectedState,
      month: selectedMonth,
      gstin
    });

    if (res.success) {
      setReportData(res.data.grouped_invoices_by_gstin || {});
    } else {
      alert(res.message || 'Failed to fetch report');
    }
  };

  const toggleGroup = (groupKey) => {
    setExpandedGroups(prev => ({ ...prev, [groupKey]: !prev[groupKey] }));
  };

  return (
    <LayoutWithNavbar>
      <div style={styles.container}>
        <h2 style={styles.heading}>Invoice Report</h2>

        {/* Filters */}
        <div style={styles.filterSection}>
          <select value={selectedState} onChange={e => setSelectedState(e.target.value)} style={styles.select}>
            <option value="">Select State</option>
            {states.map(s => (
              <option key={s.statename} value={s.statename}>{s.statename}</option>
            ))}
          </select>

          <select value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)} style={styles.select}>
            <option value="">Select Month</option>
            {getLast12Months().map(m => (
              <option key={m.value} value={m.value}>{m.label}</option>
            ))}
          </select>

          <input
            type="text"
            placeholder="GSTIN No"
            value={gstin}
            onChange={e => setGstin(e.target.value)}
            style={styles.input}
          />

          <button onClick={handleSearch} style={styles.searchButton}>Search</button>
        </div>

        {/* Result Display */}
        <div style={styles.reportSection}>
          {Object.entries(reportData).map(([group, rows]) => (
            <div key={group} style={styles.groupContainer}>
              <div onClick={() => toggleGroup(group)} style={styles.groupHeader}>
                {group} {expandedGroups[group] ? '[-]' : '[+]'}
              </div>

              {expandedGroups[group] && (
                <table style={styles.table}>
                  <thead>
                    <tr>
                      {['Trans No', 'Ref No', 'Ref Date', 'Invoice Date', 'Total Tax', 'Net Amount', 'Month', 'Overdue Days'].map((head, i) => (
                        <th key={i} style={styles.th}>{head}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((r, idx) => (
                      <tr key={idx}>
                        <td style={styles.td}>{r.trans_no}</td>
                        <td style={styles.td}>{r.ref_no}</td>
                        <td style={styles.td}>{r.ref_date}</td>
                        <td style={styles.td}>{r.invoice_date}</td>
                        <td style={styles.td}>{r.total_tax}</td>
                        <td style={styles.td}>{r.net_amount}</td>
                        <td style={styles.td}>{r.month}</td>
                        <td style={styles.td}>{r.overdue_days}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          ))}
        </div>
      </div>
    </LayoutWithNavbar>
  );
};

const styles = {
  container: {
    padding: '30px',
    backgroundColor: '#f9f9f9',
    minHeight: '100vh',
    fontFamily: 'Segoe UI, sans-serif'
  },
  heading: {
    fontSize: '26px',
    marginBottom: '25px',
    fontWeight: '600',
    textAlign: 'left'
  },
  filterSection: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    width: '100%',
    marginBottom: '30px',
    boxShadow: '0 0 8px rgba(0,0,0,0.05)'
  },
  select: {
    padding: '10px',
    fontSize: '16px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    flex: '1'
  },
  input: {
    padding: '10px',
    fontSize: '16px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    flex: '1'
  },
  searchButton: {
    padding: '10px 20px',
    fontSize: '16px',
    fontWeight: '600',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer'
  },
  reportSection: {
    width: '100%'
  },
  groupContainer: {
    marginBottom: '25px',
    border: '1px solid #dee2e6',
    borderRadius: '6px',
    backgroundColor: '#fff',
    boxShadow: '0 0 10px rgba(0,0,0,0.04)'
  },
  groupHeader: {
    padding: '12px 18px',
    backgroundColor: '#343a40',
    color: '#fff',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    borderTopLeftRadius: '6px',
    borderTopRightRadius: '6px'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse'
  },
  th: {
    padding: '12px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: '1px solid #dee2e6',
    fontSize: '18px',
    textAlign: 'left'
  },
  td: {
    padding: '12px',
    border: '1px solid #dee2e6',
    fontSize: '15px',
    backgroundColor: '#fcfcfc'
  }
};

export default ReportPage;
